import './style.css';

const SolidityIcon = props => (
    <svg xmlns="http://www.w3.org/2000/svg" className={ [ 'coe__solidityIcon', props.className ].join( ' ' ) } viewBox="0 0 523.9 813">
        <path className="st0" d="M391.9 0l-130.7 232.3H0L130.6 0 391.9 0"/>
        <path className="st1" d="M261.2 232.3h261.3L391.9 0h-261.3L261.2 232.3z"/>
        <path className="st2" d="M130.6 464.5l130.6-232.2L130.6 0 0 232.3 130.6 464.5z"/>
        <path className="st0" d="M131.9 813l130.7-232.3h261.3L393.2 813H131.9"/>
        <path className="st1" d="M262.6 580.7h-261.3L131.9 813H393.2L262.6 580.7z"/>
        <path className="st2" d="M393.2 348.5l-130.6 232.2L393.2 813l130.7-232.3L393.2 348.5z"/>
    </svg>
)

export default SolidityIcon